import { PROJECT_CODE } from "./company.js";
import { getCookieDomain, getEnv } from "./env.js";
import Cookies from "js-cookie";
const ACCOUNT_KEY = "account";
const getCookieKey = () => {
    return `${PROJECT_CODE}-${getEnv()}-${ACCOUNT_KEY}`;
};
export const getAccountNameFromSession = () => {
    const storageKey = getCookieKey();
    const savedAccountId = Cookies.get(storageKey);
    return savedAccountId;
};
export const setAccountNameToSession = (accountName) => {
    const storageKey = getCookieKey();
    Cookies.set(storageKey, accountName, {
        expires: 365 * 10,
        domain: getCookieDomain(),
    });
};
export const clearAccountNameFromSession = () => {
    const storageKey = getCookieKey();
    Cookies.remove(storageKey, {
        domain: getCookieDomain(),
    });
};
//# sourceMappingURL=session.js.map